<div
  class="alert-container"
  [class.alert-container--top-left]="(config$ | async)?.position === 'top-left'"
  [class.alert-container--top-center]="
    (config$ | async)?.position === 'top-center'
  "
  [class.alert-container--top-right]="
    (config$ | async)?.position === 'top-right'
  "
  [class.alert-container--bottom-left]="
    (config$ | async)?.position === 'bottom-left'
  "
  [class.alert-container--bottom-center]="
    (config$ | async)?.position === 'bottom-center'
  "
  [class.alert-container--bottom-right]="
    (config$ | async)?.position === 'bottom-right'
  "
>
  @for (alert of alerts$ | async; track trackById($index, alert)) {
    <app-alert-item
      [alert]="alert"
      (dismiss)="onDismiss($event)"
      (action)="onAction($event)"
      [@slideIn]
    ></app-alert-item>
  }
</div>
